import { useTranslation } from 'react-i18next';
import TourMascot, { TourStepProgress } from './TourMascot.jsx';

export default function TourSheet({ stepId, pose, stepIndex, stepCount, onNext, onSkip }) {
    const { t } = useTranslation('tour');
    const title = t(`steps.${stepId}.title`);
    const body = t(`steps.${stepId}.body`);
    const primary = t(`steps.${stepId}.primary`, { defaultValue: t('continueDefault') });

    return (
        <div className="tour-root" role="dialog" aria-modal="true" aria-label={title}>
            <div className="tour-scrim" onClick={onSkip} />
            <div className="tour-sheet">
                <TourMascot pose={pose} fallback="logo" size="sheet" />
                <TourStepProgress stepIndex={stepIndex} stepCount={stepCount} />
                <h2 className="fs-5 fw-bold mb-2">{title}</h2>
                <p className="text-muted-ms mb-4" style={{ fontSize: '0.95rem', lineHeight: 1.5 }}>{body}</p>
                <button type="button" className="btn-ms btn-ms-primary btn-ms-block" onClick={onNext}>
                    {primary}
                </button>
                <button type="button" className="tour-skip tour-skip-block" onClick={onSkip}>
                    {t('skipTour')}
                </button>
            </div>
        </div>
    );
}
